import { pipe } from 'fp-ts/lib/function';
import { transformCampaignLabelCondition } from './transformCampaignLabelCondition';
import { transformIsWithinGeoLocationCondition } from './transformIsWithinGeoLocationCondition';

/**
 * Applies condition-level transformations to a single condition
 * Works with both EditableCondition and CompleteCondition types
 */
export const applyConditionTransformations = <T extends Record<string, unknown>>(
  condition: T,
): T => {
  return pipe(
    condition,
    transformCampaignLabelCondition,
    transformIsWithinGeoLocationCondition,
  ) as unknown as T;
};
